<mat-toolbar>
    <mat-toolbar-row class="justify-content-between">
        <div class="row mr-2 ml-auto">
            <ul>
                <li>
                    <button mat-button class="user mt-2 mb-3 d-flex align-items-center">
                        <img [src]="createImgPath(this.logoFile)" class="logo mr-1 p-2" />
                    </button>
                </li>
            </ul>
        </div>
        <button mat-button class="user mt-1 mb-4 d-flex align-items-right">
            <img src="../../../assets/images/final automated.png" class="user-image mr-1 p-2" />
        </button>
    </mat-toolbar-row>
</mat-toolbar>

<div class="container">
    <h1>Payment has been processed!</h1>
    <h2>This payment has already been processed. You may now close this browser tab.</h2>
</div>

<app-footer></app-footer>